<script>
export default {
  components: {},

  data() {
    return {};
  },

  beforeMount() {},

  async created() {},

  methods: {},
};
</script>
<template>
  <div id="app">
    <router-view key="router-view" />
  </div>
</template>
